"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchMatchesByText = exports.Actions = exports.initControlsByLocation = exports.resetCategorizerControls = exports.unselectGamesWithoutSelectedTournaments = exports.selectGame = exports.changeFixedTournamentIds = exports.toggleCategorizer = exports.closeCategorizer = exports.openCategorizer = exports.toggleFilters = exports.getCategorizer = exports.filterMatches = void 0;
var core_1 = __importDefault(require("@gin-betting/core"));
var lodash_1 = require("lodash");
var selectors_1 = require("./selectors");
var constants_1 = require("./constants");
var _a = core_1.default.utils, getAppliedFilters = _a.getAppliedFilters, setSearchString = _a.setSearchString, getDefaultVariables = _a.getDefaultVariables, makeAction = _a.makeAction, getMatchStatusesByLocation = _a.getMatchStatusesByLocation;
var makeSearchMatchesFn = core_1.default.entities.actions.makeSearchMatchesFn;
var searchMatches = makeSearchMatchesFn(constants_1.SEARCH_MATCHES_REQUEST);
var searchMatchesByFilters = makeSearchMatchesFn(constants_1.FILTER_MATCHES_REQUEST);
var filterMatches = function (filters) {
    setSearchString(__assign(__assign({}, getAppliedFilters()), filters));
    return searchMatchesByFilters();
};
exports.filterMatches = filterMatches;
var getCategorizer = function (inputVariables) {
    var variables = inputVariables || __assign(__assign({}, getDefaultVariables()), { matchStatuses: getMatchStatusesByLocation() });
    return {
        type: constants_1.GET_CATEGORIZER_REQUEST,
        payload: {
            method: 'getCategorizer',
            variables: variables,
        },
        meta: { isApiCall: true },
    };
};
exports.getCategorizer = getCategorizer;
var toggleFilters = function () { return makeAction(constants_1.TOGGLE_FILTERS); };
exports.toggleFilters = toggleFilters;
var openCategorizer = function () { return makeAction(constants_1.OPEN_CATEGORIZER); };
exports.openCategorizer = openCategorizer;
var closeCategorizer = function () { return makeAction(constants_1.CLOSE_CATEGORIZER); };
exports.closeCategorizer = closeCategorizer;
var toggleCategorizer = function (isOpen) { return function (dispatch, getState) {
    var currentOpenStatus = selectors_1.selectCategorizerOpenStatus(getState());
    var nextOpenStatus = lodash_1.isBoolean(isOpen) ? isOpen : !currentOpenStatus;
    if (nextOpenStatus === currentOpenStatus)
        return;
    dispatch(nextOpenStatus ? exports.openCategorizer() : exports.closeCategorizer());
}; };
exports.toggleCategorizer = toggleCategorizer;
var changeFixedTournamentIds = function (options) { return makeAction(constants_1.CHANGE_FIXED_TOURNAMENTS, options); };
exports.changeFixedTournamentIds = changeFixedTournamentIds;
var selectGame = function (options) {
    return makeAction(constants_1.SELECT_GAME, options);
};
exports.selectGame = selectGame;
var unselectGamesWithoutSelectedTournaments = function () {
    return makeAction(constants_1.UNSELECT_GAMES_WITHOUT_SELECTED_TOURNAMENTS);
};
exports.unselectGamesWithoutSelectedTournaments = unselectGamesWithoutSelectedTournaments;
var resetCategorizerControls = function () {
    return makeAction(constants_1.RESET_CATEGORIZER_CONTROL_FIELDS);
};
exports.resetCategorizerControls = resetCategorizerControls;
var initControlsByLocation = function () {
    return makeAction(constants_1.INIT_CATEGORIZER_CONTROLS_BY_LOCATION);
};
exports.initControlsByLocation = initControlsByLocation;
exports.Actions = {
    filterMatches: exports.filterMatches,
    getCategorizer: exports.getCategorizer,
    toggleFilters: exports.toggleFilters,
    changeFixedTournamentIds: exports.changeFixedTournamentIds,
    selectGame: exports.selectGame,
    resetCategorizerControls: exports.resetCategorizerControls,
    initControlsByLocation: exports.initControlsByLocation,
    unselectGamesWithoutSelectedTournaments: exports.unselectGamesWithoutSelectedTournaments,
    closeCategorizer: exports.closeCategorizer,
    openCategorizer: exports.openCategorizer,
};
var searchMatchesByText = function (filters) {
    setSearchString(__assign(__assign({}, getAppliedFilters()), filters));
    return searchMatches();
};
exports.searchMatchesByText = searchMatchesByText;
//# sourceMappingURL=actions.js.map